<script setup lang="ts">
import ProfileCompletionBar from '~/components/shared/profile/completionBar.vue'
import CompletionMessage from '~/components/shared/profile/completionMessage.vue'

import { useArtistProfileForce } from '~/composables/useArtistProfileForce'

import type Band from '~/types/band'

type Props = {
  band: Band
}
const props = defineProps<Props>()

const { bandForce, profileNudgeMessage } = useArtistProfileForce(props.band)
const localePath = useLocalePath()

const redirectionLink = computed<string>(() =>
  localePath(`/band/profile/${props.band.slug}/edit/`),
)
</script>

<template>
  <div
    v-if="bandForce < 100"
    class="tw-mx-auto tw-flex tw-h-32 tw-max-w-[660px] tw-flex-col tw-px-0 tw-py-6 md:tw-mx-0"
  >
    <div class="tw-mb-4 tw-flex tw-flex-col tw-items-center md:tw-items-start">
      <div class="tw-mb-1 tw-text-center">
        <span class="tw-text-h6" data-test-id="profileForceLabel">
          <i18n-t keypath="shared.profile.force.force00">
            <span
              class="tw-bg-grooverGradient tw-text-h6 tw-bg-clip-text tw-text-transparent"
              data-test-id="profileForceValue"
              >{{ bandForce }}%</span
            >
          </i18n-t>
        </span>
      </div>
      <CompletionMessage
        v-if="!!profileNudgeMessage"
        :msg="profileNudgeMessage"
        :redirection-link="redirectionLink"
      />
    </div>
    <div class="elem tw-relative tw-w-full tw-px-3 md:tw-px-0">
      <ProfileCompletionBar :completion-percent="bandForce" />
    </div>
  </div>
</template>
